import angular from 'angular';
import {
  loaderService,
  orgDataService,
  reportsDataService,
  ssDialogService,
  userService,
  authorizationService,
} from 'app/services';
import {
  actionIcon
} from 'app/components/global';
import TheSafeHomeController from './home.controller';
import newsCarousel from '../newsCarousel';
import theSafeHomeDirective from './home.directive';


export const routeConfig = {
  template: require('./home.html'),
  controller: 'TheSafeHomeController',
  controllerAs: 'theSafeHomeVM',
};

export default angular.module('app.components.home.theSafeHome', [
  actionIcon,
  loaderService,
  newsCarousel,
  orgDataService,
  reportsDataService,
  ssDialogService,
  userService,
  authorizationService,
])
  .directive('theSafeHome', theSafeHomeDirective)
  .controller('TheSafeHomeController', TheSafeHomeController)
  .name;

console.log('app.components.home.theSafeHome created');
